import { fromJS } from 'immutable';

import { GetChatHistory } from '../../../store/constants'

export default () => async (dispatch, getState) => {    
    dispatch({ type: GetChatHistory, data: fromJS({}) });
};